"use strict";

const detect = require('./detect.js');

var md = new MobileDetect(window.navigator.userAgent);
var ua = detect.parse(navigator.userAgent);

var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName("body")[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight || e.clientHeight || g.clientHeight;

var ismobile = false;
var openMega = null;
var currentPage = 1;

if (md.mobile())
    ismobile = true;

function animateNav() {
    console.log('Animate Nav');
  var nav = document.getElementById('nav');
//  var nav = document.querySelector('#nav:has(+section:not(#heroimage))');
  if (!nav) {return};

  var pos = window.scrollY;

  if(pos >= 100) {
    nav.classList.add('thin');
  } else {
    nav.classList.remove('thin');
  }
}

// Define the Function targetBlank()
function targetBlank() {
    // remove subdomain of current site's url and setup regex
    let internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");

    let a = document.querySelectorAll('a:not([target=_blank])');
    const alen = a.length;
    for (let i = 0; i < alen; i++) {
        let host = a[i].host; // set the host of each link
        let href = a[i].getAttribute("href"); // set the host of each link
        let isLocal = internal.test(host);
        let isJs = /^javascript/.test(href);
        let isPdf = /\.pdf$/.test(href);

        if ((!isLocal && !isJs) || isPdf) { // make sure the href doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attributes
        }
    }
}

// browser-warning
if (ua.browser.family === "IE") {
    const warning = document.querySelectorAll('.browser-warning');
    warning[0].className = 'browser-warning show';
}

document.addEventListener('DOMContentLoaded', function () {
    console.log('DOMContentLoaded');
    targetBlank();

    window.addEventListener("scroll", function(e) {
      animateNav();
    });

});
